@if(checklistData && checklistData.length > 0) {
@for(checkList of checklistData; track $index) {
<div class="mb-2">
    <nz-collapse [nzExpandIconPosition]="'end'"
        [ngClass]="checkList.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
        <nz-collapse-panel [(nzActive)]="checkList.isActive" [nzHeader]="associationHeader">

            <ng-template #associationHeader>
                <div class="checklist-header-item" tabindex="0"
                (keydown.enter)="onPanelHeaderKeyPress(checkList)">
                    <div>
                        @if(checkList.isCompleted) {<i class="fa fa-check-circle medium-icon-size"
                            aria-hidden="true"></i> }
                        {{checkList.checklistName}}
                    </div>
                    @if(checkList.totalItems > 0) {
                    <div>
                        {{checkList.totalItemsCompleted +'/' +checkList.totalItems}} Completed
                    </div>
                    }
                </div>
            </ng-template>

            @for(categories of checkList.children; track $index) {
            <nz-collapse [nzExpandIconPosition]="'end'"
                [ngClass]="categories.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
                <nz-collapse-panel [(nzActive)]="categories.isActive" [nzHeader]="categoryHeader">

                    <ng-template #categoryHeader>
                        <div class="checklist-header-item" tabindex="0"
                        (keydown.enter)="onPanelHeaderKeyPress(categories)">
                            <div>
                                @if(categories.isCompleted) {<i class="fa fa-check-circle medium-icon-size"
                                    aria-hidden="true"></i> }
                                {{categories.checklistName}}
                            </div>
                            @if(categories.totalItems > 0) {
                            <div>
                                {{categories.totalItemsCompleted +'/' +categories.totalItems}} Completed
                            </div>
                            }
                        </div>
                    </ng-template>

                    @for(checklistItem of categories.items; track $index) {
                    @if(!checklistItem.hide) {
                    <div class="mb-3 checklist-question">
                        <div class="question-text">
                            @if(isItemComplete(checklistItem)) {<i
                                class="primary-icon fa fa-check-circle medium-icon-size" nz-tooltip
                                nzTooltipTitle="Completed" role="img" aria-label="Completed"></i> }
                            @else if(isPendingRequired(checklistItem)) {<i
                                class="pending-required-icon fa fa-exclamation-circle medium-icon-size" nz-tooltip
                                nzTooltipTitle="Required - not yet completed" role="img"
                                aria-label="Required, not yet completed"></i> }
                            {{checklistItem.question}}
                            @if(isFieldRequired(checklistItem)) {<span class="required-indicator"> *</span>}
                        </div>
                        @if(checklistItem.formMasterId !== 0) {
                        <div class="question-form">
                            <ppl-button label="View Form" [ariaLabel]="checklistItem.question + 'View Form'" icon="fa fa-file-text" [customClass]="'alt-button'"
                                [iconPosition]="'right'" (click)="handleCheckListClick(checklistItem)"></ppl-button>
                        </div>
                        } @else {
                        <div class="question-form"></div>
                        }

                        @switch(checklistItem.fieldType) {
                        @case ("radio"){
                        <div class="question-body">
                            <nz-radio-group [(ngModel)]="checklistItem.value" (ngModelChange)="onValueChange(checklistItem)" class="ppl-radio-group" [disabled]="checklistItem.readonly || !isEditable">
                                @for(opt of radioOptions; track $index){
                                <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                                }
                            </nz-radio-group>
                        </div>
                        }
                        @case ("text"){
                        <div class="question-body">
                            <input nz-input [(ngModel)]="checklistItem.value" (ngModelChange)="onValueChange(checklistItem)" type="{{checklistItem.dataType}}" [disabled]="checklistItem.readonly || !isEditable"
                                placeholder="{{checklistItem.question}}" [maxlength]="checklistItem.question?.includes('Credential Number') ? 30 : null" />
                        </div>
                        }
                        @case ("label"){
                        <div class="question-body">
                            {{checklistItem.value}}
                        </div>
                        }
                        @case ("dropdown") {
                        <div class="question-body">
                            <ppl-dropdown-select
                            [(ngModel)]="checklistItem.value"
                            (ngModelChange)="onValueChange(checklistItem)"
                            [disabled]="checklistItem.readonly || !isEditable"
                            [options]="checklistItem.lookupValue"
                            [optionLabel]="'value'"
                            [optionValue]="'key'"
                            [placeholder]="checklistItem.question">
                            </ppl-dropdown-select>
                        </div>
                        }

                        @case ("checkbox"){
                        <div class="question-body">
                            @for(opt of checklistItem.lookupValue; track $index){
                                <label nz-checkbox
                                    [nzChecked]="checklistItem.value?.includes(opt.key)"
                                    (nzCheckedChange)="onCheckboxChange($event, checklistItem, opt.key)"
                                    [nzDisabled]="checklistItem.readonly || !isEditable">
                                    {{opt.value}}
                                </label>
                            }
                        </div>
                        }

                        @case ("date"){
                        <div class="question-body">
                            <nz-date-picker style="height: 32px;" [(ngModel)]="checklistItem.value" (ngModelChange)="onValueChange(checklistItem)" [disabled]="checklistItem.readonly || !isEditable"
                                [nzFormat]="'MM/dd/yyyy'"></nz-date-picker>
                        </div>
                        }
                        }

                        @if(checklistItem.showDateRange) {
                        <div class="question-body ml-4">
                            <nz-range-picker nzFormat="yyyy-MM-dd" [(ngModel)]="checklistItem.dateRange" [disabled]="checklistItem.readonly || !isEditable"
                                (ngModelChange)="onChange($event, checklistItem)"></nz-range-picker>
                        </div>
                        }
                    </div>
                    }
                    }

                    @for(subCategories of categories.children; track $index) {
                    <nz-collapse [nzExpandIconPosition]="'end'"
                        [ngClass]="subCategories.isCompleted ? 'completed completed-ant-collapse' : 'pending pending-ant-collapse'">
                        <nz-collapse-panel [(nzActive)]="subCategories.isActive" [nzHeader]="subCategoryHeader">


                            <ng-template #subCategoryHeader>
                                <div class="checklist-header-item">
                                    <div>
                                        @if(subCategories.isCompleted) {<i class="fa fa-check-circle medium-icon-size"
                                            aria-hidden="true"></i> }
                                        {{subCategories.checklistName}}
                                    </div>
                                    @if(subCategories.totalItems > 0) {
                                    <div>
                                        {{subCategories.totalItemsCompleted +'/' +subCategories.totalItems}}
                                        Completed
                                    </div>
                                    }
                                </div>
                            </ng-template>

                            @for(checklistItem of subCategories.items; track $index) {
                            @if(!checklistItem.hide) {
                            <div class="mb-3 checklist-question">
                                <div class="question-text">
                                    @if(isItemComplete(checklistItem)) {<i
                                        class="primary-icon fa fa-check-circle medium-icon-size" nz-tooltip
                                        nzTooltipTitle="Completed" role="img" aria-label="Completed"></i>
                                    }
                                    @else if(isPendingRequired(checklistItem)) {<i
                                        class="pending-required-icon fa fa-exclamation-circle medium-icon-size"
                                        nz-tooltip nzTooltipTitle="Required - not yet completed" role="img"
                                        aria-label="Required, not yet completed"></i> }
                                    {{checklistItem.question}}?
                                    @if(isFieldRequired(checklistItem)) {<span class="required-indicator"> *</span>}
                                </div>
                                @if(checklistItem.formMasterId !== 0) {
                                <div class="question-form">
                                    <ppl-button label="View Form" [ariaLabel]="checklistItem.question + 'View Form'" icon="fa fa-file-text" [customClass]="'alt-button'"
                                        [iconPosition]="'right'"
                                        (click)="handleCheckListClick(checklistItem)"></ppl-button>
                                </div>
                                } @else {
                                <div class="question-form"></div>
                                }

                                @switch(checklistItem.fieldType) {
                                @case ("radio"){
                                <div class="question-body">
                                    <nz-radio-group [(ngModel)]="checklistItem.value" class="ppl-radio-group" [disabled]="checklistItem.readonly || !isEditable">
                                        @for(opt of radioOptions; track $index){
                                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                                        }
                                    </nz-radio-group>
                                </div>
                                }
                                @case ("text"){
                                <div class="question-body">
                                    <input nz-input [(ngModel)]="checklistItem.value" type="{{checklistItem.dataType}}" [disabled]="checklistItem.readonly || !isEditable"
                                        placeholder="{{checklistItem.question}}" [maxlength]="checklistItem.question?.includes('Credential Number') ? 30 : null" />
                                </div>
                                }
                                @case ("label"){
                                <div class="question-body">
                                    {{checklistItem.value}}
                                </div>
                                }
                                @case ("dropdown") {
                                <div class="question-body">
                                    <ppl-dropdown-select
                                    [(ngModel)]="checklistItem.value"
                                    [disabled]="checklistItem.readonly || !isEditable"
                                    [options]="checklistItem.lookupValue"
                                    [optionLabel]="'value'"
                                    [optionValue]="'key'"
                                    [placeholder]="checklistItem.question">
                                    </ppl-dropdown-select>
                                </div>
                                }

                                @case ("date"){
                                <div class="question-body">
                                    <nz-date-picker [(ngModel)]="checklistItem.value" style="height: 32px;" [disabled]="checklistItem.readonly || !isEditable"
                                        [nzFormat]="'yyyy-MM-dd'"></nz-date-picker>
                                </div>
                                }
                                }

                                @if(checklistItem.showDateRange) {
                                <div class="question-body ml-4">
                                    <nz-range-picker nzFormat="yyyy-MM-dd" [(ngModel)]="checklistItem.dateRange" [disabled]="checklistItem.readonly || !isEditable"
                                        (ngModelChange)="onChange($event, checklistItem)"></nz-range-picker>
                                </div>
                                }
                            </div>
                            }
                            }
                        </nz-collapse-panel>
                    </nz-collapse>
                    <span class="mt-1">&nbsp;</span>
                    }
                </nz-collapse-panel>
            </nz-collapse>
            <span class="mt-1">&nbsp;</span>
            }
        </nz-collapse-panel>
    </nz-collapse>
</div>
}
}
@else if (showNoRecordsMesssage){
<nz-alert class="mb-2" nzType="info" [nzMessage]="message" nzShowIcon></nz-alert>
}